import Radio from './radio.vue';
import RadioGroup from './radio-group.vue';

Radio.Group = RadioGroup;
export default Radio;


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/components/radio/index.js
// module id = 66
// module chunks = 0